import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ChevronLeft from "../progress/svg/ChevronLeft";
import { navigationStep } from "../../../redux/slices/navigation";
import useCurrentLocation from "../../../hooks/useCurrentLocation";
import HeaderAvatar from "./components/HeaderAvatar";

export default function ContentStepHeader() {
  const langNav = useSelector((state) => state.changeLang.language.nav);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { entryLocationEdit, pageNumber, localePath } = useCurrentLocation();

  const handleBack = () => {
    if (entryLocationEdit) {
      const pageParam = pageNumber ? `?page=${pageNumber}` : "";
      window.location.href = `${localePath}/entry/${pageParam}`;
    } else {
      dispatch(navigationStep(1));
      navigate("/");
    }
  };

  return (
    <div
      className="position-fixed top-0 start-0 w-100 bg-white py-2 d-flex align-items-center px-3"
      style={{ zIndex: 500, height: "48px" }}
    >
      <button
        onClick={handleBack}
        className="btn p-0 border-0 bg-transparent"
        style={{ width: "24px" }}
        aria-label={langNav.desktop[0]}
      >
        <ChevronLeft />
      </button>
      <div className="fw-bold fs-8 text-center position-absolute start-50 translate-middle-x">
        {langNav.showStep[1]}
      </div>
      <div className="ms-auto">
        <HeaderAvatar />
      </div>
    </div>
  );
}
